// Should match the value in /app/views/shared/_gtm_datalayer.html.slim
const STORAGE_KEY = 'ww-cookie-consent'

class CookieBanner extends HTMLElement {
	/** @typedef {'granted' | 'denied' | 'prompting'} Consent  */

	/** @type Consent */
	consent = this.#getStoredConsent()

	/** @param consent {Exclude<Consent, 'prompting'>} */
	#getGTMConsentObj(consent) {
		return {
			analytics_storage: consent,
			ad_storage: consent,
			ad_user_data: consent,
			ad_personalization: consent,
			functionality_storage: consent,
			personalization_storage: consent,
		}
	}

	/** @param consent {Exclude<Consent, 'prompting'>} */
	#setStoredConsent(consent) {
		const event = new StorageEvent('storage', {
			key: STORAGE_KEY,
			newValue: consent,
		})

		localStorage.setItem(STORAGE_KEY, consent)
		window.dispatchEvent(event)
	}

	#getStoredConsent() {
		const stored = localStorage.getItem(STORAGE_KEY)
		if (stored === 'granted' || stored === 'denied') {
			return stored
		}

		return 'prompting'
	}

	promptForConsent() {
		this.consent = 'prompting'
		this.hidden = false
	}

	connectedCallback() {
		if (this.consent === 'prompting') {
			this.hidden = false
		}

		/** @type {HTMLButtonElement} */
		const acceptBtn = this.querySelector('[data-accept]')
		/** @type {HTMLButtonElement} */
		const rejectBtn = this.querySelector('[data-reject]')

		acceptBtn.addEventListener('click', () => {
			this.#setStoredConsent('granted')
		})

		rejectBtn.addEventListener('click', () => {
			this.#setStoredConsent('denied')
		})

		window.addEventListener('storage', (e) => {
			if (e.key !== STORAGE_KEY) return

			const stored = e.newValue
			if (stored !== 'granted' && stored !== 'denied') {
				return this.promptForConsent()
			}

			this.hidden = true
			this.consent = stored

			const gtmObj = this.#getGTMConsentObj(stored)
			window.gtag?.('consent', 'update', gtmObj)
		}, { passive: true })
	}
}

customElements.define('cookie-banner', CookieBanner)
